import React, { useEffect, useState } from "react";
import {
  FaCog,
  FaFilePdf,
  FaSms,
  FaExchangeAlt,
  FaUsersCog,
  FaClipboardList,
  FaPlay,
  FaInfoCircle,
} from "react-icons/fa";

import axios from "axios";
import"../../App.css"

const Setting = () => {
  
  const [showSecurityModal, setShowSecurityModal] = useState(false);
const [securityPasscode, setSecurityPasscode] = useState("");
const [securitySaving, setSecuritySaving] = useState(false);
  const [billContact, setBillContact] = useState("");
  const [loyalty, setLoyalty] = useState(1);
  const [thermalSize, setThermalSize] = useState("3 Inches");
const [theme, setTheme] = useState("Light");
  const [settings, setSettings] = useState({});
  const [activeTab, setActiveTab] = useState("general");
const [showTermsModal, setShowTermsModal] = useState(false);

const [termsText, setTermsText] = useState(() => {
  return localStorage.getItem("terms_condition_text") || "";
});

const [termsCondition, setTermsCondition] = useState(() => {
  return localStorage.getItem("terms_condition_enabled") === "1";
});




  const [security, setSecurity] = useState(false);
  const [estimateBilling, setEstimateBilling] = useState(false);
  const [deliveryBilling, setDeliveryBilling] = useState(false);
  const [regularPrinterDefault, setRegularPrinterDefault] =
  useState(true);


const [loyaltyAmount, setLoyaltyAmount] = useState(10);
const [thermalPrinterDefault, setThermalPrinterDefault] =useState(false);
  useEffect(() => {
  getSettings();
}, []);

// const savedTermsEnabled =
//   localStorage.getItem("terms_condition_enabled");

// if (savedTermsEnabled !== null) {
//   setTermsCondition(savedTermsEnabled === "1");
// } else {
//   setTermsCondition(Number(data.printTnc) === 1);
// }
const saveTermsCondition = () => {
  const text = termsText.trim();

  if (!text) {
    alert("Please enter Terms & Conditions.");
    return;
  }

  localStorage.setItem("terms_condition_text", text);
  localStorage.setItem("terms_condition_enabled", "1");

  setTermsText(text);
  setTermsCondition(true);
  setShowTermsModal(false);
};


const disableSecurity = async () => {
  try {
    const clientId = localStorage.getItem("client_id");

    if (!clientId) {
      alert("Client ID not found.");
      return;
    }

    await axios.put(
      `https://api.dectwinbilling.com/update-settings/${clientId}`,
      {
        key: "isSecurity",
        value: 0,
      }
    );

    localStorage.removeItem("security_passcode");
    localStorage.removeItem("security_enabled");

    const currentSettings =
      JSON.parse(localStorage.getItem("settings")) || {};

    localStorage.setItem(
      "settings",
      JSON.stringify({
        ...currentSettings,
        isSecurity: 0,
      })
    );

    setSecurity(false);

  } catch (error) {
    console.error(
      "Disable security error:",
      error.response?.data || error.message
    );
  }
};
const saveSecurityPasscode = async () => {
  try {
    if (!/^\d{4}$/.test(securityPasscode)) {
      alert("Please enter exactly 4 digits.");
      return;
    }

    const clientId = localStorage.getItem("client_id");

    if (!clientId) {
      alert("Client ID not found.");
      return;
    }

    setSecuritySaving(true);

    // DB: only existing column
    await axios.put(
      `https://api.dectwinbilling.com/update-settings/${clientId}`,
      {
        key: "isSecurity",
        value: 1,
      }
    );

    // Save passcode locally
    localStorage.setItem(
      "security_passcode",
      securityPasscode
    );

    localStorage.setItem(
      "security_enabled",
      "1"
    );

    // Update local settings
    const currentSettings =
      JSON.parse(localStorage.getItem("settings")) || {};

    localStorage.setItem(
      "settings",
      JSON.stringify({
        ...currentSettings,
        isSecurity: 1,
      })
    );

    // IMPORTANT: toggle purple
    setSecurity(true);

    // Close modal
    setShowSecurityModal(false);
    setSecurityPasscode("");

  } catch (error) {
    console.error(
      "Security save error:",
      error.response?.data || error.message
    );

    setSecurity(false);
    alert("Failed to enable security.");
  } finally {
    setSecuritySaving(false);
  }
};
const getSettings = async () => {
  try {
    const clientId = localStorage.getItem("client_id");

    if (!clientId) {
      console.error("client_id not found");
      return;
    }

    const response = await axios.get(
      `https://api.dectwinbilling.com/settings/${clientId}`
    );

    // Backend response support:
    // response.data
    // OR response.data.data
    const data = response.data?.data || response.data || {};

    console.log("SETTINGS FROM DATABASE:", data);

    setSettings(data);

    setSecurity(Number(data.isSecurity) === 1);
    setEstimateBilling(Number(data.isEstimate) === 1);
    setDeliveryBilling(Number(data.isDelivery) === 1);

    setRegularPrinterDefault(Number(data.thermal_print) === 0);
    setThermalPrinterDefault(Number(data.thermal_print) === 1);
setCompanyAddress(Number(data.printAdd) === 1);

// Terms localStorage se load
const savedTermsEnabled = localStorage.getItem(
  "terms_condition_enabled"
);

if (savedTermsEnabled !== null) {
  setTermsCondition(savedTermsEnabled === "1");
} else {
  setTermsCondition(Number(data.printTnc) === 1);
}

// Terms text localStorage se load
const savedTermsText =
  localStorage.getItem("terms_condition_text") || "";

setTermsText(savedTermsText);

setMultiUserMode(Number(data.dis_on_txn) === 1);
    // setCompanyAddress(Number(data.printAdd) === 1);
    // setTermsCondition(Number(data.printTnc) === 1);
    // setMultiUserMode(Number(data.dis_on_txn) === 1);

    // ==========================================
    // THEME FROM DATABASE
    // ==========================================
    const savedTheme =
      String(data.theme_color || "Light").trim().toLowerCase() === "dark"
        ? "Dark"
        : "Light";

    console.log("THEME FROM DATABASE:", data.theme_color);
    console.log("THEME USED:", savedTheme);

    setTheme(savedTheme);

    // Save SAME data in localStorage
    localStorage.setItem(
      "settings",
      JSON.stringify({
        ...data,
        theme_color: savedTheme,
      })
    );

    setThermalSize(data.thermal_size || "3 Inches");
    setLoyalty(data.set_loyal || 1);
    setLoyaltyAmount(data.set_loyal_amount || 10);
    setBillContact(data.bill_contact || "");

  } catch (error) {
    console.error("Get settings error:", error);
  }
};
// const getSettings = async () => {
//   try {
//     const clientId = localStorage.getItem("client_id");

// const response = await axios.get(
//   `https://api.dectwinbilling.com/settings/${clientId}`
// );

// const data = response.data;

// setSettings(data);

// setSecurity(Number(data.isSecurity) === 1);
// setEstimateBilling(Number(data.isEstimate) === 1);
// setDeliveryBilling(Number(data.isDelivery) === 1);

// setRegularPrinterDefault(Number(data.thermal_print) === 0);
// setThermalPrinterDefault(Number(data.thermal_print) === 1);

// setCompanyAddress(Number(data.printAdd) === 1);
// setTermsCondition(Number(data.printTnc) === 1);
// setMultiUserMode(Number(data.dis_on_txn) === 1);
// const savedTheme =
//   data?.theme_color === "Dark" ? "Dark" : "Light";

// setTheme(savedTheme);
// // setTheme(data.theme_color || "Water Blue");
// setThermalSize(data.thermal_size || "3 Inches");
// setLoyalty(data.set_loyal || 1);
// setLoyaltyAmount(data.set_loyal_amount || 10);
// setBillContact(data.bill_contact || "");
// localStorage.setItem("settings", JSON.stringify(data));

// localStorage.setItem(
//   "settings",
//   JSON.stringify(response.data.data)
// );

// console.log(response.data);


//   } catch (error) {
//     console.log(error);
//   }
// };
const updateSetting = async (key, value) => {
  try {
    const clientId = localStorage.getItem("client_id");

    if (!clientId) {
      console.error("client_id not found");
      return;
    }

    console.log("UPDATING SETTING:", {
      clientId,
      key,
      value,
    });

    // ==========================================
    // FRONTEND IMMEDIATE UPDATE
    // ==========================================

    const currentSettings =
      JSON.parse(localStorage.getItem("settings")) || {};

    const updatedSettings = {
      ...currentSettings,
      [key]: value,
    };

    localStorage.setItem(
      "settings",
      JSON.stringify(updatedSettings)
    );

    // Theme immediately apply
    if (key === "theme_color") {
      setTheme(value);

      window.dispatchEvent(
        new CustomEvent("appThemeChanged", {
          detail: value,
        })
      );
    }

    // ==========================================
    // DATABASE UPDATE
    // ==========================================

    const response = await axios.put(
      `https://api.dectwinbilling.com/update-settings/${clientId}`,
      {
        key: key,
        value: value,
      }
    );

    console.log(
      "DATABASE UPDATE RESPONSE:",
      response.data
    );

  } catch (error) {
    console.error(
      "DATABASE SETTING UPDATE ERROR:",
      error.response?.data || error
    );
  }
};
// const updateSetting = async (key, value) => {
//   try {
//     const clientId = localStorage.getItem("client_id");

//     // ==========================================
//     // FRONTEND: CHANGE IMMEDIATELY
//     // ==========================================
//     const currentSettings =
//       JSON.parse(localStorage.getItem("settings")) || {};

//     const updatedSettings = {
//       ...currentSettings,
//       [key]: value,
//     };

//     localStorage.setItem(
//       "settings",
//       JSON.stringify(updatedSettings)
//     );

//     // Theme ko API response ka wait mat karvao
//     if (key === "theme_color") {
//       window.dispatchEvent(
//         new CustomEvent("appThemeChanged", {
//           detail: value,
//         })
//       );
//     }

//     // ==========================================
//     // BACKEND: SAVE
//     // ==========================================
//     await axios.put(
//       `https://api.dectwinbilling.com/update-settings/${clientId}`,
//       {
//         key,
//         value,
//       }
//     );

//     console.log("Setting updated:", key, value);

//   } catch (error) {
//     console.error("Update setting error:", error);
//   }
// };
// const updateSetting = async (key, value) => {
//   try {
//     const clientId = localStorage.getItem("client_id");

//     await axios.put(
//       `https://api.dectwinbilling.com/update-settings/${clientId}`,
//       {
//         key,
//         value,
//       }
//     );

//     // LocalStorage update
//     const data =
//       JSON.parse(localStorage.getItem("settings")) || {};

//  data[key] = Number(value);

//     localStorage.setItem("settings", JSON.stringify(data));
//   } catch (error) {
//     console.log(error);
//   }
// };

//   const handleRegularPrinter = () => {
//   setRegularPrinterDefault(true);
//   setThermalPrinterDefault(false);
//      updateSetting("thermal_print", 0);
// };

// const handleThermalPrinter = () => {
//   setRegularPrinterDefault(false);
//   setThermalPrinterDefault(true);

//     updateSetting("thermal_print", 1);
// };
const handleRegularPrinter = () => {

  setRegularPrinterDefault(true);
  setThermalPrinterDefault(false);
  updateSetting("thermal_print", 0);
};

const handleThermalPrinter = () => {
  setThermalPrinterDefault(true);
  setRegularPrinterDefault(false);
  updateSetting("thermal_print", 1);
};
  const [companyAddress, setCompanyAddress] = useState(false);
  // const [companyPhone, setCompanyPhone] = useState(true);
  const [companyPhone, setCompanyPhone] = useState(() => {
  return localStorage.getItem("company_contact") === "1";
});
  const [multipleContacts, setMultipleContacts] = useState(false);
// const [companyEmail, setCompanyEmail] = useState(false);
const [companyEmail, setCompanyEmail] = useState(() => {
  return localStorage.getItem("company_email") === "1";
});
const [companyGSTIN, setCompanyGSTIN] = useState(() => {
  const saved = localStorage.getItem("company_gstin");

  // Agar pehli baar hai to default ON
  return saved === null ? true : saved === "1";
});

const [showTime, setShowTime] = useState(false);


const [printDiscount, setPrintDiscount] = useState(() => {
  const saved = localStorage.getItem("print_discount");
  return saved === null ? true : saved === "1";
});

const [printQuantity, setPrintQuantity] = useState(() => {
  const saved = localStorage.getItem("print_quantity");
  return saved === null ? true : saved === "1";
});


const [printGSTBreakup, setPrintGSTBreakup] = useState(false);
const [printDescription, setPrintDescription] = useState(true);
const [saleSMS, setSaleSMS] = useState(false);
const [purchaseSMS, setPurchaseSMS] = useState(false);
const [estimateSMS, setEstimateSMS] = useState(false);
const [saleReturnSMS, setSaleReturnSMS] = useState(false);
const [purchaseReturnSMS, setPurchaseReturnSMS] = useState(false);
const [deliverySMS, setDeliverySMS] = useState(false);
 
const [cashSaleDefault, setCashSaleDefault] = useState(true);
const [enableRoundOff, setEnableRoundOff] = useState(false);
const [allowNegativeStock, setAllowNegativeStock] = useState(false);
const [autoBackup, setAutoBackup] = useState(true);
const [multiUserMode, setMultiUserMode] = useState(true);
const [defaultActiveStaff, setDefaultActiveStaff] = useState(true);
const [overviewAddedStaff, setOverviewAddedStaff] = useState(false);

const [wholesalePrice, setWholesalePrice] = useState(false);
const [retailPrice, setRetailPrice] = useState(true);
const [itemCode, setItemCode] = useState(true);
const [itemBarcode, setItemBarcode] = useState(true);
const [itemImage, setItemImage] = useState(false);
const [stockAlert, setStockAlert] = useState(true);
const [negativeStock, setNegativeStock] = useState(false);
const [multiUnit, setMultiUnit] = useState(false);
const [batchWiseItem, setBatchWiseItem] = useState(false);
const [expiryDate, setExpiryDate] = useState(true);

//   const menuItems = [
//   {
//     key: "general",
//     // icon: <FaCog />,
//     icon: <FaCog color="#4281f7" />,
//     title: "General Settings",
//     textColor: "#0d6efd",
//     bg: "#fff",
//   },
//   {
//     key: "invoice",
//     icon: <FaFilePdf />,
//     title: "Invoice/PDF Print",
//     bg: "#c2185b",
//   },
//   {
//     key: "sms",
//     icon: <FaSms />,
//     title: "Transaction SMS",
//     bg: "#ff9800",
//   },
//   {
//     key: "transaction",
//     icon: <FaExchangeAlt />,
//     title: "Transaction",
//     bg: "#009688",
//   },
//   {
//     key: "user",
//     icon: <FaUsersCog />,
//     title: "User Management",
//     bg: "#3f51b5",
//   },
//   {
//     key: "items",
//     icon: <FaClipboardList />,
//     title: "Items Settings",
//     bg: "#2196f3",
//   },
// ];

const menuItems = [
  {
    key: "general",
    icon: <FaCog size={32} color="#4281f7" />,
    title: "General Settings",
    textColor: "#0d6efd",
    bg: "#e1e9f5",
    borderColor: "#4281f7", 
  },
  {
    key: "invoice",
    icon: <FaFilePdf size={32} color="#ef4444" />,
    title: "Invoice/PDF Print",
    bg: "#f7e3e3",
    textColor: "#ef4444",
    borderColor: "#ef4444", 
  },
  {
    key: "sms",
    icon: <FaSms size={32} color="#f59e0b" />,
    title: "Transaction SMS",
    bg: "#faf4eb",
    textColor: "#f59e0b",
    borderColor: "#f59e0b", 
  },
  {
    key: "transaction",
    icon: <FaExchangeAlt size={32} color="#10b981" />,
    title: "Transaction",
    bg: "#dbf3eb",
    textColor: "#10b981",
    borderColor: "#10b981", 
  },
  {
    key: "user",
    icon: <FaUsersCog  size={32}color="#8b5cf6" />,
    title: "User Management",
    bg: "#e0d9f0",
    textColor: "#8b5cf6",
    borderColor: "#8b5cf6", 
  },
  {
    key: "items",
    icon: <FaClipboardList  size={32}color="#06b6d4" />,
    title: "Items Settings",
    bg: "#ddf0f3",
    textColor: "#06b6d4",
    borderColor: "#06b6d4", 
  },
];
  // const Toggle = ({ checked, onChange }) => (
  //   <div
  //     onClick={() => onChange(!checked)}
  //     style={{
  //       width: "52px",
  //       height: "30px",
  //       background: checked ? "#6f52ed" : "#d9d9d9",
  //       borderRadius: "30px",
  //       position: "relative",
  //       cursor: "pointer",
  //       transition: "0.3s",
  //     }}
  //   >
  //     <div
  //       style={{
  //         width: "24px",
  //         height: "24px",
  //         background: "#fff",
  //         borderRadius: "50%",
  //         position: "absolute",
  //         top: "3px",
  //         left: checked ? "25px" : "3px",
  //         transition: "0.3s",
  //       }}
  //     />
  //   </div>
  // );
const Toggle = ({ checked, onChange }) => (
  <div
    // onClick={() => onChange()}
        onClick={() => onChange(!checked)}
    style={{
      width: "52px",
      height: "30px",
      background: checked ? "#6f52ed" : "#d9d9d9",
      borderRadius: "30px",
      position: "relative",
      cursor: "pointer",
      transition: "0.3s",
    }}
  >
    <div
      style={{
        width: "24px",
        height: "24px",
        background: "#fff",
        borderRadius: "50%",
        position: "absolute",
        top: "3px",
        left: checked ? "25px" : "3px",
        transition: "0.3s",
      }}
    />
  </div>
);
  return (
    <div className="container-fluid py-2">
      <div className="card border-0 shadow rounded-4 overflow-hidden">
      <div className="card-header d-flex justify-content-between align-items-center py-3 settings-header">
        {showSecurityModal && (
  <div
    className="security-modal-overlay"
    onClick={() => {
      if (!securitySaving) {
        setShowSecurityModal(false);
        setSecurityPasscode("");
      }
    }}
  >
    <div
      className="security-passcode-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <h4>Enter Passcode</h4>

      <input
        type="password"
        inputMode="numeric"
        maxLength={4}
        autoFocus
        value={securityPasscode}
        placeholder="Enter 4 digit passcode"
        onChange={(e) => {
          const value = e.target.value
            .replace(/\D/g, "")
            .slice(0, 4);

          setSecurityPasscode(value);
        }}
      />

      <button
        type="button"
        className="btn btn-primary"
        disabled={
          securitySaving ||
          securityPasscode.length !== 4
        }
        onClick={saveSecurityPasscode}
      >
        {securitySaving
          ? "Saving..."
          : "Set Passcode"}
      </button>
    </div>
  </div>
)}
        {/* <div
          className="card-header d-flex justify-content-between align-items-center py-3"
          style={{ background: "#dce8f4" }}
        > */}
          <h2 className="fw-bold mb-0">
            <FaCog className="text-primary me-2" />
            Settings
          </h2>

          <button
            className="btn text-white fw-bold rounded-3 px-4"
            style={{ background: "#0d67a7" }}
          >
            <FaPlay className="me-2" />
            WATCH TUTORIALS
          </button>
        </div>

   
        <div
          className="card-body p-4"
          style={{ background: "#dce8f4" }}
        >
          <div
            className="p-4 rounded-5"
            style={{
              // border: "2px solid var(--primary-color)",
              background: "#dce8f4",
            }}
          >
            <div className="row">
          
              <div className="col-12 mb-4">
  <div className="bg-white p-4 rounded-5">
    <div className="row g-3">
      {menuItems.map((item, index) => (
        <div className="col-md-4" key={index}>
<button
  onClick={() => {
    console.log("Clicked Tab:", item.key);
    setActiveTab(item.key);
  }}
  className="btn  fw-bold w-100 py-3 rounded-pill"
// style={{
//   background: item.bg,
//   color: item.textColor,

//   border: activeTab === item.key
//     ? "none"
//     : `2px solid ${item.borderColor}`,

//   outline: activeTab === item.key
//     ? "2px solid #111827"
//     : "none",

//   outlineOffset: "2px",
//   transition: "all 0.3s ease",
// }}
style={{
  background: activeTab === item.key ? item.bg : "#fff",
  color: item.textColor,

  border: `2px solid ${item.borderColor}`,

  // Active hone par left accent bhi usi color ka
  borderLeft:
    activeTab === item.key
      ? `8px solid ${item.borderColor}`
      : `2px solid ${item.borderColor}`,

  // Active glow bhi usi color ka
  boxShadow:
    activeTab === item.key
      ? `0 8px 20px ${item.borderColor}40`
      : "0 2px 8px rgba(0,0,0,.06)",

  transform:
    activeTab === item.key
      ? "translateY(-2px)"
      : "translateY(0)",

  transition: "all .3s ease",
}}
>
  <span className="me-2">{item.icon}</span>
  {item.title}
</button>
        </div>
      ))}
    </div>
  </div>
</div>

           <div
  className="col-lg-8"
  
 
>
  
  {/* <div className="alert alert-primary mb-3"> */}
    {/* Current Tab : <strong>{activeTab}</strong> */}
  </div>{activeTab === "general" && (
  <>
                <h3 className="fw-bold mb-4">
                  General Settings
                </h3>

                {/* Theme */}
                <div className="row align-items-center mb-4">
                  <div className="col-md-7">
                    <h5>
                      Change App Theme{" "}
                      <FaInfoCircle size={14} />
                    </h5>
                  </div>

                  <div className="col-md-5">
<select
  className="form-select border-0 shadow-sm rounded-4"
  style={{ height: "46px" }}
  value={theme}
  onChange={(e) => {
    const newTheme = e.target.value;

    setTheme(newTheme);

    updateSetting(
      "theme_color",
      newTheme
    );
  }}
>
  <option value="Light">Light</option>
  <option value="Dark">Dark</option>
</select>
                   {/* <select
  className="form-select border-0 shadow-sm rounded-4"
  style={{ height: "46px" }}
  value={theme}
  onChange={(e) => {
    setTheme(e.target.value);
    updateSetting("theme_color", e.target.value);
  }}
>
 
  <option value="Dark">Dark</option>
  <option value="Light">Light</option>
</select> */}
                  </div>
                </div>

             
                <div className="row align-items-center mb-3">
                  <div className="col-md-9">
                    <h5>
                      Enable Security{" "}
                      <FaInfoCircle size={14} />
                    </h5>
                  </div>
              <div className="col-md-3 d-flex justify-content-end pe-4">
{/* <Toggle
  checked={security}
  onChange={(value) => {
    setSecurity(value);
    updateSetting("isSecurity", value);
  }}
/> */}
<Toggle
  checked={security}
  onChange={(value) => {
    if (value) {
      // OFF → ON
      // Pehle passcode maango
      setSecurityPasscode("");
      setShowSecurityModal(true);
    } else {
      // ON → OFF
      disableSecurity();
    }
  }}
/>
</div>
                </div>

                {/* <div className="row align-items-center mb-3">
                  <div className="col-md-9">
                    <h5>
                      Estimate/Quotation Billing{" "}
                      <FaInfoCircle size={14} />
                    </h5>
                  </div>
                  <div className="col-md-3 d-flex justify-content-end pe-4">
                  <Toggle
  checked={estimateBilling}
  onChange={(value) => {
    setEstimateBilling(value);
    updateSetting("isEstimate", value);
  }}
/>
                  </div>
                </div> */}

                {/* <div className="row align-items-center mb-4">
                  <div className="col-md-9">
                    <h5>
                      Delivery Challan Billing{" "}
                      <FaInfoCircle size={14} />
                    </h5>
                  </div>
                  <div className="col-md-3 d-flex justify-content-end pe-4">
                <Toggle
  checked={deliveryBilling}
  onChange={(value) => {
    setDeliveryBilling(value);
    updateSetting("isDelivery", value);
  }}
/>
                  </div>
                </div> */}
                </>
)}

            {activeTab === "invoice" && (
  <>
    {/* Printer */}
<div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mt-5 mb-4">
      <h3 className="fw-bold mb-0">
        Invoice/PDF Print
      </h3>

{/* <div className="d-flex flex-column flex-md-row gap-2 gap-md-3 w-80 w-md-auto mt-3 mt-md-0">
        <button
          className={`btn fw-bold w-80 rounded-pill ${
            regularPrinterDefault
              ? "btn-success text-white"
              : "btn-light"
          }`} 
          onClick={handleRegularPrinter}
        >
          ✓ Regular Printer
        </button>

        <button
          className={`btn fw-bold w-80 rounded-pill ${
            thermalPrinterDefault
              ? "btn-success text-white"
              : "btn-light"
          }`}
          onClick={handleThermalPrinter}
        >
          ● Thermal Printer
        </button>
      </div> */}
      <div className="d-flex flex-column flex-md-row gap-3 mt-3 mt-md-0">
  <button
    className={`btn fw-bold rounded-pill px-4 ${
      regularPrinterDefault ? "btn-success text-white" : "btn-light"
    }`}
    onClick={handleRegularPrinter}
  >
    ✓ Regular Printer
  </button>

  <button
    className={`btn fw-bold rounded-pill px-4 ${
      thermalPrinterDefault ? "btn-success text-white" : "btn-light"
    }`}
    onClick={handleThermalPrinter}
  >
    ● Thermal Printer
  </button>
</div>
    </div>

   <div className="row align-items-center mb-3">
  <div className="col-md-9">
    <h5>
      Make Regular Printer Default{" "}
      <FaInfoCircle size={14} />
    </h5>
  </div>

  <div className="col-md-3 d-flex justify-content-end pe-4">
    <Toggle
      checked={regularPrinterDefault}
      onChange={handleRegularPrinter}
    />
  </div>
</div>
<div className="row align-items-center mb-3">
  <div className="col-md-9">
    <h5>
      Make Thermal Printer Default{" "}
      <FaInfoCircle size={14} />
    </h5>
  </div>

  <div className="col-md-3 d-flex justify-content-end pe-4">
    <Toggle
      checked={thermalPrinterDefault}
      onChange={handleThermalPrinter}
    />
  </div>
</div>

    <div className="row align-items-center mb-4">
      <div className="col-md-7">
        <h5>
          Select Thermal Printer Size{" "}
          <FaInfoCircle size={14} />
        </h5>
      </div>

      <div className="col-md-5">
      <select
  className="form-select border-0 shadow-sm rounded-4"
  style={{ height: "46px" }}
  value={thermalSize}
  onChange={(e) => {
    const value = Number(e.target.value);
    setThermalSize(value);
    updateSetting("thermal_size", value);
  }}
>
  <option value={3}>3 Inches</option>
  <option value={2}>2 Inches</option>
  <option value={4}>4 Inches</option>
</select>
      </div>
    </div>
  
    
  
                <h3 className="fw-bold mb-3">
                  Header Content
                </h3>
<div className="row align-items-center mb-3">
  <div className="col-md-7">
    <h5>
      Contact No for Bill Display <FaInfoCircle size={14} />
    </h5>
  </div>

  <div className="col-md-5">
    <input
      type="text"
      className="form-control rounded-4"
      placeholder="Contact No"
      value={billContact}
      onChange={(e) => {
        const value = e.target.value;
        setBillContact(value);
        updateSetting("bill_contact", value);
      }}
    />
  </div>
</div>
                <div className="row align-items-center mb-3">
                  <div className="col-md-9">
                    <h5>
                      Print Company Address{" "}
                      <FaInfoCircle size={14} />
                    </h5>
                  </div>

                  <div className="col-md-3 d-flex justify-content-end pe-4">
                   <Toggle
  checked={companyAddress}
  onChange={(value) => {
    setCompanyAddress(value);
    updateSetting("printAdd", value);
  }}
/>
                  </div>
                  
                </div>
                <div className="row align-items-center mb-3">
                  <div className="col-md-9">
                    <h5>
                      Print Company Phone{" "}
                      <FaInfoCircle size={14} />
                    </h5>
                  </div>

                  {/* <div className="col-md-3 d-flex justify-content-end pe-4">
                    <Toggle
               checked={companyPhone}
                  onChange={(value) => {
                setCompanyPhone(value);
}}
/>
                  </div> */}


                  <div className="col-md-3 d-flex justify-content-end pe-4">
  <Toggle
    checked={companyPhone}
    onChange={(value) => {
      const isOn = Boolean(value);

      setCompanyPhone(isOn);

      // Save 1 when ON, 0 when OFF
      localStorage.setItem("company_contact", isOn ? "1" : "0");
    }}
  />
</div>
                  
                </div>
                
<div className="row align-items-center mb-3">
                  <div className="col-md-9">
                    <h5>
                      Print multiple Contacts {" "}
                      <FaInfoCircle size={14} />
                    </h5>
                  </div>

                  <div className="col-md-3 d-flex justify-content-end pe-4">
                    <Toggle
                      checked={multipleContacts}
                      onChange={setMultipleContacts}
                    />
                  </div>
                  
                </div>
                

                

          
                  

                   
       

<div className="row align-items-center mb-3">
  <div className="col-md-9">
    <h5>Print Company Email <FaInfoCircle size={14} /></h5>
  </div>
  <div className="col-md-3 d-flex justify-content-end pe-4">
    <Toggle
  checked={companyEmail}
  onChange={(value) => {
    const isOn = Boolean(value);

    setCompanyEmail(isOn);

    localStorage.setItem(
      "company_email",
      isOn ? "1" : "0"
    );
  }}
/>
    {/* <Toggle checked={companyEmail} onChange={setCompanyEmail} /> */}
  </div>
</div>

<div className="row align-items-center mb-4">
  <div className="col-md-9">
    <h5>Print Company GSTIN <FaInfoCircle size={14} /></h5>
  </div>
  <div className="col-md-3 d-flex justify-content-end pe-4">
   <Toggle
  checked={companyGSTIN}
  onChange={(value) => {
    const isOn = Boolean(value);

    setCompanyGSTIN(isOn);

    localStorage.setItem(
      "company_gstin",
      isOn ? "1" : "0"
    );
  }}
/>
  </div>
</div>
<h3 className="fw-bold mb-3">Body Content</h3>

<div className="row align-items-center mb-3">
  <div className="col-md-9">
    <h5>Show Time on Invoices <FaInfoCircle size={14} /></h5>
  </div>
  <div className="col-md-3 d-flex justify-content-end pe-4">
    <Toggle checked={showTime} onChange={setShowTime} />
  </div>
</div>

{/* <div className="row align-items-center mb-3">
  <div className="col-md-9">
    <h5>Print Items Discount <FaInfoCircle size={14} /></h5>
  </div>
  <div className="col-md-3 d-flex justify-content-end pe-4">
    <Toggle checked={printDiscount} onChange={setPrintDiscount} />
  </div>
</div> */}
<div className="row align-items-center mb-3">
  <div className="col-md-9">
    <h5>
      Print Items Discount <FaInfoCircle size={14} />
    </h5>
  </div>

  <div className="col-md-3 d-flex justify-content-end pe-4">
    <Toggle
      checked={printDiscount}
      onChange={(value) => {
        const isOn = Boolean(value);

        setPrintDiscount(isOn);

        localStorage.setItem(
          "print_discount",
          isOn ? "1" : "0"
        );
      }}
    />
  </div>
</div>

<div className="row align-items-center mb-4">
  <div className="col-md-9">
    <h5>
      Print Items Quantity <FaInfoCircle size={14} />
    </h5>
  </div>

  <div className="col-md-3 d-flex justify-content-end pe-4">
    <Toggle
      checked={printQuantity}
      onChange={(value) => {
        const isOn = Boolean(value);

        setPrintQuantity(isOn);

        localStorage.setItem(
          "print_quantity",
          isOn ? "1" : "0"
        );
      }}
    />
  </div>
</div>
<h3 className="fw-bold mb-3">Footer Content</h3>

<div className="row align-items-center mb-3">
  <div className="col-md-9">
    <h5>Terms and Conditions <FaInfoCircle size={14} /></h5>
  </div>
  <div className="col-md-3 d-flex justify-content-end pe-4">
<Toggle
  checked={termsCondition}
  onChange={(value) => {
    if (value) {
      setShowTermsModal(true);
    } else {
      setTermsCondition(false);

      localStorage.setItem(
        "terms_condition_enabled",
        "0"
      );
    }
  }}
/>
{showTermsModal && (
  <div
    className="terms-modal-overlay"
    onClick={() => setShowTermsModal(false)}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.55)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 99999,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: "360px",
        maxWidth: "90%",
        background: "#f3edf5",
        borderRadius: "25px",
        padding: "12px 10px 20px",
        boxShadow: "0 15px 40px rgba(0,0,0,0.3)",
      }}
    >
      <h5
        style={{
          textAlign: "center",
          fontWeight: "700",
          marginBottom: "8px",
        }}
      >
        Enter Terms & Conditions
      </h5>

      <textarea
        value={termsText}
        onChange={(e) => setTermsText(e.target.value)}
        placeholder="Enter Terms & Conditions"
        rows={3}
        autoFocus
        style={{
          width: "100%",
          border: "none",
          borderBottom: "1px solid #999",
          outline: "none",
          background: "transparent",
          resize: "none",
          padding: "8px 10px",
          fontSize: "14px",
        }}
      />

      <div className="d-flex justify-content-center mt-3">
        <button
          type="button"
          onClick={saveTermsCondition}
          style={{
            border: "none",
            borderRadius: "20px",
            padding: "8px 22px",
            background: "#42a5f5",
            color: "#fff",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}
  </div>
</div>

<div className="row align-items-center mb-3">
  <div className="col-md-9">
    <h5>Print GST Breakup <FaInfoCircle size={14} /></h5>
  </div>
  <div className="col-md-3 d-flex justify-content-end pe-4">
    <Toggle checked={printGSTBreakup} onChange={setPrintGSTBreakup} />
  </div>
</div>

<div className="row align-items-center mb-4">
  <div className="col-md-9">
    <h5>Print Description <FaInfoCircle size={14} /></h5>
  </div>
  <div className="col-md-3 d-flex justify-content-end pe-4">
    <Toggle checked={printDescription} onChange={setPrintDescription} />
  </div>
</div>
</>
)}

{activeTab === "sms" && (
  <>
    <h3 className="fw-bold mb-3">Transaction SMS</h3>

    {[
      ["Sale Transaction SMS", saleSMS, setSaleSMS],
      ["Purchase Transaction SMS", purchaseSMS, setPurchaseSMS],
      ["Estimate Transaction SMS", estimateSMS, setEstimateSMS],
      ["Sale Return Transaction SMS", saleReturnSMS, setSaleReturnSMS],
      ["Purchase Return Txn SMS", purchaseReturnSMS, setPurchaseReturnSMS],
      ["Delivery Challan SMS", deliverySMS, setDeliverySMS],
    ].map(([label, value, setter], index) => (
      <div className="row align-items-center mb-3" key={index}>
        <div className="col-md-9">
          <h5>{label}</h5>
        </div>

        <div className="col-md-3 d-flex justify-content-end pe-4">
          <Toggle
            checked={value}
            onChange={setter}
          />
        </div>
      </div>
    ))}
  </>
)}
{activeTab === "transaction" && (
  <>
<h3 className="fw-bold mb-3">Transaction</h3>

<div className="row align-items-center mb-3">
  <div className="col-md-9">
    <h5>Cash Sale by Default <FaInfoCircle size={14} /></h5>
  </div>
  <div className="col-md-3 d-flex justify-content-end pe-4">
    <Toggle
      checked={cashSaleDefault}
      onChange={setCashSaleDefault}
    />
  </div>
</div>

<div className="row align-items-center mb-3">
  <div className="col-md-9">
    <h5>
      show PP on items suggestions <FaInfoCircle size={14} /></h5>
  </div>
  <div className="col-md-3 d-flex justify-content-end pe-4">
    <Toggle
      checked={enableRoundOff}
      onChange={setEnableRoundOff}
    />
  </div>
</div>
<div className="row align-items-center mb-3">
  <div className="col-md-9">
    <h5>
      Set Loyalty Percentage <FaInfoCircle size={14} />
    </h5>
  </div>

  <div className="col-md-3">
    <input
      type="number"
      step="0.1"
      className="form-control"
      value={loyalty}
      onChange={(e) => {
        const value = e.target.value;
        setLoyalty(value);
        updateSetting("set_loyal", value);
      }}
    />
  </div>
</div>

<div className="row align-items-center mb-3">
  <div className="col-md-9">
    <h5>
      Set Loyalty Redemption Amount <FaInfoCircle size={14} />
    </h5>
  </div>

  <div className="col-md-3">
    <input
      type="number"
      className="form-control"
      value={loyaltyAmount}
      onChange={(e) => {
        const value = e.target.value;
        setLoyaltyAmount(value);
        updateSetting("set_loyal_amount", value);
      }}
    />
  </div>
</div>

<div className="row align-items-center mb-4">
  <div className="col-md-9">
    <h5>Transaction Wise Discount <FaInfoCircle size={14} /></h5>
  </div>
  <div className="col-md-3 d-flex justify-content-end pe-4">
  <Toggle
  checked={multiUserMode}
  onChange={(value) => {
    setMultiUserMode(value);
    updateSetting("dis_on_txn", value);
  }}
/>
  </div>
</div>
</>
)}
{activeTab === "user" && (
  <>

<h3 className="fw-bold mb-3">User Management</h3>

<div className="row align-items-center mb-3">
  <div className="col-md-9">
    <h5>Default Active Staff <FaInfoCircle size={14} /></h5>
  </div>
  {/* <div className="col-md-3"> */}
  <div
  className="col-md-3 d-flex justify-content-end"
  style={{ paddingRight: "30px" }}
>
    <Toggle
      checked={defaultActiveStaff}
      onChange={setDefaultActiveStaff}
    />
  </div>
</div>

<div className="row align-items-center mb-3">
  <div className="col-md-9">
    <h5>On Overview for Added Staff <FaInfoCircle size={14} /></h5>
  </div>
  <div className="col-md-3 d-flex justify-content-end pe-4">
    <Toggle
      checked={overviewAddedStaff}
      onChange={setOverviewAddedStaff}
    />
  </div>
</div>
</>
)}

{activeTab === "items" && (
  <>
    <h3 className="fw-bold mb-3">Items Settings</h3>

    <div className="row align-items-center mb-3">
      <div className="col-md-9">
        <h5>
          Wholesale Price <FaInfoCircle size={14} />
        </h5>
      </div>

      <div className="col-md-3 d-flex justify-content-end pe-4">
        <Toggle
          checked={wholesalePrice}
          onChange={setWholesalePrice}
        />
      </div>
    </div>
  </>
)}





                  
               
                
              </div>


            </div>
          </div>
        </div>
      </div> 

    
  );
};

export default Setting;
